/**
 * twenty-fifty-pullback-page.js
 *
 * 20-50 EMA Pullback strategy — across Weekly, Daily, 4H:
 *   Long:  20 EMA > 50 EMA · both sloping up · price between them (below 20, above 50)
 *   Short: 20 EMA < 50 EMA · both sloping down · price between them (above 20, below 50)
 */

import React from 'react';
import StrategySignalsPage from './strategy-signals-page';
import { fetchTwentyFiftyPullbackData } from '../services/server-api';
import { formatPrice } from '../utils/format-helpers';

const TF_LABELS = { weekly: 'Weekly', daily: 'Daily', fourHour: '4H' };

function slopeLabel(slope) {
  if (slope === 'up')   return '↑ rising';
  if (slope === 'down') return '↓ falling';
  return '→ flat';
}

function renderDetails(entry) {
  const ema20Val = entry.ema20 != null ? formatPrice(entry.ema20) : '—';
  const ema50Val = entry.ema50 != null ? formatPrice(entry.ema50) : '—';
  return (
    <>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">20 EMA</span>
        <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>
          {ema20Val} {slopeLabel(entry.ema20Slope)}
        </span>
      </div>
      <div className="mtf-ind-row">
        <span className="mtf-ind-label">50 EMA</span>
        <span className={`mtf-ind-value ${entry.state === 'long' ? 'bull' : 'bear'}`}>
          {ema50Val} {slopeLabel(entry.ema50Slope)}
        </span>
      </div>
    </>
  );
}

function TwentyFiftyPullbackPage() {
  return (
    <StrategySignalsPage
      config={{
        title:      '20-50 Pullback',
        icon:       '〽️',
        subtitle:   '20 EMA > 50 EMA both trending · price pulls back into the zone between them',
        fetchFn:    fetchTwentyFiftyPullbackData,
        timeframes: ['weekly', 'daily', 'fourHour'],
        tfLabels:   TF_LABELS,
        renderDetails,
      }}
    />
  );
}

export default TwentyFiftyPullbackPage;
